import React, { FC } from 'react';

import { BettingContext } from 'app/contexts/betting';
import $betting from 'app/contexts/betting/$search';

import Content from './Content';

type SearchProps = {
  className?: string;
  onLinkClick: VoidFunction;
};

const Search: FC<SearchProps> = ({
  onLinkClick,
}) => {
  return (
    <BettingContext.Provider value={$betting}>
      <Content onLinkClick={onLinkClick} />
    </BettingContext.Provider>
  );
};

export default Search;
